import Maths from '@/business/utils/maths';

function fullfillAttributeWithRef({
  attributesObjRef,
  attributesObj,
  attribute,
}) {
  if (!attributesObjRef) return null;
  const newAttributesObj = { ...attributesObj };
  newAttributesObj[attribute] = {
    serverSide: attributesObjRef[attribute].serverSide,
    type: attributesObjRef[attribute].type,
    values: attributesObjRef[attribute].values.map((value) => value.id),
  };
  return newAttributesObj;
}
function fullfillAttributesObjWithRef({ attributesObjRef, attributesObj }) {
  if (!attributesObjRef) return null;
  const newAttributesObj = { ...attributesObj };
  Object.keys(attributesObjRef).forEach((key) => {
    newAttributesObj[key] = {
      serverSide: attributesObjRef[key].serverSide,
      type: attributesObjRef[key].type,
      values: attributesObjRef[key].values.map((value) => value.id),
    };
  });
  return newAttributesObj;
}

function formatAttributesObjWithRef({ attributesObjRef, attributesObj }) {
  if (!attributesObjRef) return null;
  const newAttributesObj = {};
  Object.keys(attributesObjRef).forEach((key) => {
    newAttributesObj[key] = {
      serverSide: attributesObjRef[key].serverSide,
      type: attributesObjRef[key].type,
      values: [],
    };
  });
  return { ...newAttributesObj, ...attributesObj };
}

function clearAttribute({ attributesObjRef, attributesObj, attribute }) {
  const newAttributesObj = { ...attributesObj };
  newAttributesObj[attribute] = {
    serverSide: attributesObjRef[attribute].serverSide,
    type: attributesObjRef[attribute].type,
    values: [],
  };
  return newAttributesObj;
}
function clearAttributesObj({ attributesObjRef, attributesObj }) {
  const newAttributesObj = { ...attributesObj };
  Object.keys(attributesObjRef).forEach((key) => {
    newAttributesObj[key] = {
      serverSide: attributesObjRef[key].serverSide,
      type: attributesObjRef[key].type,
      values: [],
    };
  });
  return newAttributesObj;
}

function isAttributeEqualToRef({ attributesObjRef, attributesObj, attribute }) {
  return (
    attributesObj[attribute] &&
    Maths.arrayContainsArray(
      attributesObj[attribute].values,
      attributesObjRef[attribute].values.map((value) => value.id)
    )
  );
}

function isAttributesObjEqualToRef({ attributesObjRef, attributesObj }) {
  return Object.keys(attributesObjRef).every((attribute) =>
    isAttributeEqualToRef({ attributesObjRef, attributesObj, attribute })
  );
}

function isAttributeObjDirty({ attributesObjRef, attributesObj }) {
  return Object.keys(attributesObjRef).reduce(
    (sum, attribute) =>
      sum +
      (attributesObj[attribute] && !attributesObj[attribute].auto
        ? attributesObj[attribute].values.filter((el) => !!el).length
        : 0),
    0
  );
}

function isSearchDirty({ and, or }) {
  return Object.keys(and).some((field) => and[field] && and[field] !== '') ||
    Object.keys(or).some((field) => or[field] && or[field] !== '')
    ? 1
    : 0;
}

export {
  formatAttributesObjWithRef,
  fullfillAttributesObjWithRef,
  clearAttributesObj,
  clearAttribute,
  fullfillAttributeWithRef,
  isAttributesObjEqualToRef,
  isAttributeEqualToRef,
  isAttributeObjDirty,
  isSearchDirty,
};
